if (window.location.pathname === "/inyeccion/periodo" || window.location.pathname === "/zona-trabajo") {

    document.addEventListener('click', function (e) {
        const btnModalEliminar = e.target.closest('#btnEliminarPncInyeccion');
        if (!btnModalEliminar) return;

        const formEditar = document.querySelector("#formEditarPncInyeccion");
        const formEliminar = document.querySelector("#formEliminarPncInyeccion");

        if (!formEditar || !formEliminar) return;

        const inputLineaEditar = formEditar.querySelector("#idLineaPncInyeccion");
        const inputReporteEditar = formEditar.querySelector("#idEncabezadoReporteInyeccion");

        const inputLineaEliminar = formEliminar.querySelector("#idLineaPncInyeccion");
        const inputReporteEliminar = formEliminar.querySelector("#idEncabezadoReporteInyeccion");

        if (!inputLineaEditar || !inputReporteEditar || !inputLineaEliminar || !inputReporteEliminar) {
            if (typeof lanzarAlerta === 'function') {
                lanzarAlerta("Faltan datos para eliminar el PNC.", "alerta-roja");
            }
            return;
        }

        inputLineaEliminar.value = inputLineaEditar.value || "";
        inputReporteEliminar.value = inputReporteEditar.value || "";
    });


    document.addEventListener('submit', async function (e) {
        if (e.target.id !== 'formEliminarPncInyeccion') return;

        const botonActivo = e.submitter;

        if (!botonActivo || botonActivo.id !== 'btnEliminarPncInyeccion') {
            return;
        }

        e.preventDefault();

        const formulario = e.target;
        const modalEditarPnc = document.querySelector("#modalEditarPncInyeccion");
        const modalPadre = formulario.closest('.modal');
        const btnEliminar = botonActivo;
        const spinner = btnEliminar.querySelector('#spinner') || formulario.querySelector('#spinner');

        if (!formulario.checkValidity()) {
            formulario.reportValidity();
            return;
        }

        if (btnEliminar) btnEliminar.disabled = true;
        if (spinner) spinner.style.display = 'inline-block';

        formulario.querySelectorAll('.inputRojo').forEach(function (input) {
            input.classList.remove('inputRojo');
        });

        try {
            const formData = new FormData(formulario, botonActivo);

            const respuesta = await fetch('/api/inyeccion/eliminar-pnc', {
                method: 'POST',
                body: formData,
                credentials: 'include'
            });

            let json = null;

            try {
                json = await respuesta.json();
            } catch (errorJson) {
                throw new Error('La respuesta del servidor no es JSON válido.');
            }

            if (!respuesta.ok) {
                console.error('Error HTTP:', respuesta.status, json);

                if (typeof lanzarAlerta === 'function') {
                    lanzarAlerta('Error al procesar la eliminación.', 'alerta-roja');
                } else {
                    alert('Error al procesar la eliminación.');
                }

                return;
            }

            if (!json || !json.result) {
                console.error('Respuesta inesperada:', json);

                if (typeof lanzarAlerta === 'function') {
                    lanzarAlerta('Respuesta inesperada del servidor.', 'alerta-roja');
                }

                return;
            }

            const resultado = json.result;

            if (resultado.hayErrores) {
                if (Array.isArray(resultado.errores)) {
                    resultado.errores.forEach(function (error) {
                        if (typeof lanzarAlerta === 'function') {
                            lanzarAlerta(
                                error.mensaje || 'Error de validación.',
                                error.clase || 'alerta-roja'
                            );
                        }

                        if (error.campo) {
                            const campo = formulario.querySelector('[name="' + error.campo + '"]');
                            if (campo) campo.classList.add('inputRojo');
                        }
                    });
                }

                return;
            }

            const idReporteInput = formulario.querySelector('#idEncabezadoReporteInyeccion');
            const idReporte = idReporteInput ? idReporteInput.value : '';

            const params = new URLSearchParams(window.location.search);
            const mes = params.get("mes");
            const anio = params.get("año");

            if (modalPadre) modalPadre.classList.remove('modal--show');
            if (modalEditarPnc) modalEditarPnc.classList.remove('modal--show');

            if (typeof lanzarAlerta === 'function') {
                lanzarAlerta("Registro eliminado con éxito.", "alerta-verde");
            }

            if (typeof window.actualizarModalReporteInyeccion === 'function' && idReporte) {
                window.actualizarModalReporteInyeccion(idReporte);
            }

            if (typeof window.actualizarTableroInyeccionPeriodo === 'function') {
                window.actualizarTableroInyeccionPeriodo(mes, anio);
            }

            if (typeof window.actualizarTablaInyeccionPeriodo === 'function') {
                window.actualizarTablaInyeccionPeriodo(mes, anio);
            }
            if (typeof window.actualizarZonaTrabajo === 'function') {
                if (window.location.pathname === "/zona-trabajo") window.actualizarZonaTrabajo();
            }

        } catch (error) {
            console.error("Error:", error);

            if (typeof lanzarAlerta === 'function') {
                lanzarAlerta("Error crítico al procesar la solicitud.", "alerta-roja");
            } else {
                alert("Error crítico al procesar la solicitud.");
            }

        } finally {
            if (btnEliminar) btnEliminar.disabled = false;
            if (spinner) spinner.style.display = 'none';
        }
    });
}